import { Provider } from "../../../../data/entities";
import ContactPersonForm from "./ContactPerson";
import ContactList from "./ContactList";
import {PageContentWrapper} from "../../../../shared/styled/PageContentStyle";
import useMergeState from "../../../../shared/hooks/useMergeState";
import { normalizeProviderContactList } from "../providerData";

interface FormContainerProps {
  validated: boolean;
  mergeProvider: Function;
  providerData: Provider;
}

const FormContainer = ({
  validated,
  mergeProvider,
  providerData,
}: FormContainerProps) => {
  const contact_list = normalizeProviderContactList(providerData.contact_list);
  const [contactPerson, setContactPerson] = useMergeState(providerData);

  const nextId = contact_list.reduce((currentMax: number, contact: any) => {
    const contactId = Number(contact.id);
    return Number.isFinite(contactId)
      ? Math.max(currentMax, contactId)
      : currentMax;
  }, 0);

  const handleChangePersonContact = (updatePersonContact: any) => {
    const updatedContactPerson = {
      ...contactPerson,
      name: updatePersonContact.name,
      provider_code: updatePersonContact.provider_code,
      phone: updatePersonContact.phone,
      tax_id: updatePersonContact.tax_id,
      fax: updatePersonContact.fax,
      email: updatePersonContact.email,
      address: updatePersonContact.address,
      is_internal: updatePersonContact.is_internal,
      is_outsource_provider: updatePersonContact.is_outsource_provider,
      payable_days: updatePersonContact.payable_days,
      bank_account_name: updatePersonContact.bank_account_name,
      bank_account_number: updatePersonContact.bank_account_number,
      bank_name: updatePersonContact.bank_name,
      contact_list: contact_list,
    };

    setContactPerson(updatedContactPerson);
    mergeProvider(updatedContactPerson);
  };

  const handleChangeContactList = (updateContact: any) => {
    const updateContactList = contact_list.map((contact: any) => {
      if (contact.id === updateContact.id) {
        return {
          ...contact,
          contact: {
            ...contact.contact,
            is_default: updateContact.is_default,
            name: updateContact.name,
            phone: updateContact.phone,
            email: updateContact.email,
            position: updateContact.position,
          },
        };
      } else if (updateContact.is_default) {
        return {
          ...contact,
          contact: {
            ...contact.contact,
            is_default: false,
          },
        };
      }
      return contact;
    });
    mergeProvider({ contact_list: updateContactList });
  };

  const handleAddContact = () => {
    const addContactList = [
      ...contact_list,
      {
        id: nextId + 1,
        contact: {
          is_default: false,
          name: "",
          phone: "",
          email: "",
          position: "",
        },
      },
    ];
    mergeProvider({ contact_list: addContactList });
  };

  const handleDeleteContact = (contactId: number) => {
    const deleteContact = contact_list.filter(
      (contact: any) => contact.id !== contactId,
    );
    mergeProvider({ contact_list: deleteContact });
  };

  return (
    <PageContentWrapper>
      <ContactPersonForm
        validated={validated}
        providerData={providerData}
        handleChangePersonContact={handleChangePersonContact}
      />
      <ContactList
        validated={validated}
        contactList={contact_list}
        onChangeContactList={handleChangeContactList}
        onAddContact={handleAddContact}
        onDeleteContact={handleDeleteContact}
      />
    </PageContentWrapper>
  );
};

export default FormContainer;
